var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('error-start'),_c('ta-start-element',{attrs:{"onClick":_vm.start}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }